import Datatable from "../../Components/Datatable"
import { useTranslation } from "react-i18next";
import React, { useState, useEffect, useMemo } from "react";
import axios from "axios";
import { useAuth } from '../../../../../context/AuthContext';
import { API_BASE_URL } from "../../../../../Helpers/apiConfig";

const formatDate = (isoString) => {
    if (!isoString) return "-";
    const date = new Date(isoString);
    if (isNaN(date.getTime())) return isoString;
    return date.toLocaleString("tr-TR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit"
    });
};

const TYPE_META = {
    "deposit-inv": { label: "Bireysel İlk Satın Alma", badgeClass: "bg-success" },
    "extend-inv": { label: "Bireysel Uzatma", badgeClass: "bg-primary" },
    "deposit-co": { label: "Kurumsal İlk Satın Alma", badgeClass: "bg-danger" },
    "extend-co": { label: "Kurumsal Uzatma", badgeClass: "bg-warning text-dark" },
};

export const AdminPaymentRecords = () => {
    const { user } = useAuth();
    const [msgg, setMsgg] = useState([]);
    const [loadingg, setLoadingg] = useState(false);
    const { t } = useTranslation()
    const [banks, setBanks] = useState([]);
    const [packages, setPackages] = useState([]);
    const [filtereddata, setFiltereddata] = useState([]);
    const [categoryFilter, setCategoryFilter] = useState("all"); // all | corporate | individual

    const columnsFiltered = React.useMemo(
        () => [
            {
                Header: "Yöntem",
                Footer: "Yöntem",
                accessor: 'paymentInfo',
            },
            {
                Header: "Paket",
                Footer: "Paket",
                accessor: 'packageInfo',
            },
            {
                Header: "İstek Türü",
                Footer: "İstek Türü",
                accessor: (originalRow) => (
                    <span className={`badge ${TYPE_META[originalRow.type]?.badgeClass || "bg-secondary"}`}>
                        {originalRow.station}
                    </span>
                ),
                id: 'station',
                Footer: "İstek Türü",
            },
            {
                Header: "Durum",
                Footer: "Durum",
                accessor: 'status',
            },
            {
                Header: t("transactionDate"),
                Footer: t("transactionDate"),
                accessor: 'transactionDate',
            },
            {
                Header: "E-posta",
                Footer: "E-posta",
                accessor: 'username',
            },
            {
                Header: t("namesurname"),
                Footer: t("namesurname"),
                accessor: 'userFullName',
            },
            {
                Header: "Yönetici Notu",
                Footer: "Yönetici Notu",
                accessor: 'note',
            },
            {
                Header: "Kupon Kodu",
                Footer: "Kupon Kodu",
                accessor: 'cuponCode',
            },
        ],
        [],
    )

    const fetchBanksAndPackages = async () => {
        const headerss = {
            "accept": "*/*",
            'Content-Type': 'application/json',
            'Access-Control-Allow-Credentials': 'false',
            'Authorization': 'Bearer ' + user.token
        }

        const banksRes = await axios({
            method: 'GET',
            url: API_BASE_URL + "/admin/Gateway/GetList",
            headers: headerss
        });
        let localBanks = [];
        if (banksRes.status === 200 && banksRes.data['success']) {
            localBanks = banksRes.data['data'].map(dt => ({
                id: dt['id'],
                gatewayName: dt['gatewayName'],
            }));
            setBanks(localBanks);
        }

        const packagesRes = await axios({
            method: 'GET',
            url: API_BASE_URL + "/admin/Package/GetList",
            headers: headerss
        });
        let localPackages = [];
        if (packagesRes.status === 200 && packagesRes.data['success']) {
            localPackages = packagesRes.data['data'].map(dt => ({
                id: dt['id'],
                packageName: dt['packageName'],
            }));
            setPackages(localPackages);
        }

        return { localBanks, localPackages };
    }

    const fetchRecords = async (start, end) => {
        setLoadingg(true);
        setMsgg("");

        try {
            const { localBanks, localPackages } = await fetchBanksAndPackages();

            const headerss = {
                "accept": "*/*",
                'Content-Type': 'application/json',
                'Access-Control-Allow-Credentials': 'false',
                'Authorization': 'Bearer ' + user.token
            }
            let url = API_BASE_URL + "/admin/Subscription/GetList";
            const res = await axios({
                method: 'Get',
                url: url,
                params: { start, end },
                headers: headerss
            });

            if (res.status === 200 && res.data['success']) {
                const rows = [];
                for (let i = 0; i < res.data['data'].length; i++) {
                    const item = res.data['data'][i];
                    const type = item['transaction']['type'];
                    const station = TYPE_META[type]?.label || type;

                    const bank = localBanks.find(b => b.id === item['transaction']['gatewayId']);
                    const paymentInfo = bank ? bank.gatewayName : (item['transaction']['gatewayId'] ?? "-");

                    const pkg = localPackages.find(p => p.id === item['transaction']['package']);
                    const packageInfo = pkg ? pkg.packageName : item['transaction']['package'];

                    let status = "";
                    if (item['transaction']['status'] === "requested") status = t('requested');
                    else if (item['transaction']['status'] === "approved") status = t('successfull');
                    else if (item['transaction']['status'] === "rejected") status = t('rejected');

                    rows.push({
                        "id": item['transaction']['id'],
                        "paymentInfo": paymentInfo,
                        "packageInfo": packageInfo,
                        "station": station,
                        "type": type,
                        "status": status,
                        "transactionDate": formatDate(item['transaction']['transactionDate']),
                        "username": item['username'],
                        "userFullName": item['userFullName'],
                        "note": item['transaction']['note'],
                        "cuponCode": item['transaction']['cuponCode'],
                    });
                }
                setFiltereddata(rows);
                if (rows.length === 0) {
                    setMsgg("Sonuç bulunamadı");
                }
            } else {
                setMsgg(res.data['message']);
            }
        } catch (err) {
            setMsgg(err.message);
        }
        setLoadingg(false);
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        const start = document.getElementById("startdate").value + "T00:01";
        const end = document.getElementById("finishdate").value + "T23:59";
        await fetchRecords(start, end);
    }

    const handleShowAll = async () => {
        await fetchRecords("2000-01-01T00:01", "2100-01-01T23:59");
    }

    const displayedData = useMemo(() => {
        if (categoryFilter === "corporate") {
            return filtereddata.filter(row => row.type === "deposit-co" || row.type === "extend-co");
        }
        if (categoryFilter === "individual") {
            return filtereddata.filter(row => row.type === "deposit-inv" || row.type === "extend-inv");
        }
        return filtereddata;
    }, [filtereddata, categoryFilter]);

    return (
        <div style={{ textAlign: "center" }}>
            <br />
            <h1>Kayıtlar</h1>

            <div className="d-flex justify-content-center flex-wrap gap-2 mb-3">
                {Object.entries(TYPE_META).map(([key, meta]) => (
                    <span key={key} className={`badge ${meta.badgeClass}`}>
                        {meta.label}
                    </span>
                ))}
            </div>

            <h4> {msgg} </h4>

            <form onSubmit={handleSubmit} className="card shadow-sm border-0 mx-auto mb-3" style={{ maxWidth: "560px" }}>
                <div className="card-body p-3 p-md-4">
                    <div className="row g-3">
                        <div className="col-12 col-md-6">
                            <label className="form-label" htmlFor="startdate">{t("startdate")}</label>
                            <input type="date" className="form-control" id="startdate" name="startdate" required />
                        </div>
                        <div className="col-12 col-md-6">
                            <label className="form-label" htmlFor="finishdate">{t("finishdate")}</label>
                            <input type="date" className="form-control" id="finishdate" name="finishdate" required />
                        </div>
                    </div>
                    <div className='d-flex justify-content-center gap-2 mt-4'>
                        <button type="submit" className="btn btn-primary btn-lg px-4">{t("showdetails")}</button>
                        <button type="button" className="btn btn-outline-secondary btn-lg px-4" onClick={handleShowAll}>
                            Tüm Kayıtları Gör
                        </button>
                    </div>
                </div>
            </form>

            {filtereddata.length > 0 && (
                <div className="d-flex justify-content-center gap-2 mb-3">
                    <button
                        className={`btn btn-sm ${categoryFilter === "all" ? "btn-dark" : "btn-outline-dark"}`}
                        onClick={() => setCategoryFilter("all")}
                    >
                        Tümü
                    </button>
                    <button
                        className={`btn btn-sm ${categoryFilter === "corporate" ? "btn-danger" : "btn-outline-danger"}`}
                        onClick={() => setCategoryFilter("corporate")}
                    >
                        Kurumsal Kayıtları Gör
                    </button>
                    <button
                        className={`btn btn-sm ${categoryFilter === "individual" ? "btn-success" : "btn-outline-success"}`}
                        onClick={() => setCategoryFilter("individual")}
                    >
                        Bireysel Kayıtları Gör
                    </button>
                </div>
            )}

            {loadingg && <div>Veriler yükleniyor...</div>}

            {!loadingg && filtereddata.length > 0 && (
                <div>
                    <Datatable data={displayedData} columns={columnsFiltered} tableBaslik={t('getpaymentrequestwithDate')} />
                </div>
            )}
        </div>
    )
}
export default AdminPaymentRecords;
